import React, {Component} from 'react';
import propTypes from 'prop-types';
import {Redirect, Route} from "react-router-dom";
import $ from "jquery";
import axios from "axios";
import Data from "./Data";
import DateFnsUtils  from '@date-io/date-fns';
import moment from "moment";
import { MuiPickersUtilsProvider , TimePicker } from "@material-ui/pickers";
import { TextField } from '@material-ui/core';

class ModalAddClass extends Component {

    constructor(props){
        super(props);
        moment.locale("en");
        let date = new Date(0, 0, 0, 16);
        let datee = new Date(0, 0, 0, 18);
        let time1 = moment(date).format("HH:mm");
        let time2 = moment(datee).format("HH:mm");
        let time = time1+"-"+time2;
        this.state = {
            fields : {
                inst : 0,
                classname : "",
                instrumentList : [],
                price : 0,
                isGroup : false,
                fromtime : date,
                totime : datee,
                time : time,
                dayid : 0,
                day : "شنبه",
                file : this.props.products['picture'],
                
            },
            timeopen1:false,
            timeopen2:false,
            errors : {

            }
        }

    }

    componentDidMount() {
        axios.post(Data.server+`getInstruments2.php`)
            .then(response => {

                if (response.data.hasOwnProperty('data')) {

                    const {data} = response.data;
                    const {fields} = this.state;
                    fields.instrumentList = data;
                    fields.classname = data[0]['name'];
                    this.setState({fields});

                }
                
            })
            .catch(error => {
                console.log(error)
            });
    }

    handleChange(event){
        let fields = this.state.fields;
        let target = event.target;
        if (target.name == "inst"){
            fields['classname'] = fields.instrumentList[target.value]['name'];
        }
        if (target.name == "isGroup"){
            fields['isGroup'] = target.checked;
            if(target.checked){
                fields['classname'] = "گروه نوازی ("+fields['classname']+")";
            }else{
                fields['classname'] = fields.instrumentList[fields['inst']]['name'];
            }
            this.setState({fields});
            return;
        }
        if (target.name == "dayid"){
            fields['day'] = target.children[target.value].innerText;
            console.log(target.value);
        }
        fields[target.name] = target.value;
        this.setState({fields});

    }

    handleSubmit(event){

        event.preventDefault();

        this.handleValidation((valid)=>{
            if (valid){
                $('#'+this.props.id).modal('hide');
                this.handleRequest();
            } else {

            }
        })

    }

    handleValidation(callback){
        let { fields } = this.state;
        let errors = this.state.errors;
        let formIsValid = true;
        console.log("handleValidation");

        
        if (fields.classname === ""){
            formIsValid = false;
            errors['classname'] = 'لطفا نام کلاس را وارد کنید!';
        }else {
            errors['classname'] = null;
        }
        if (fields.price === ""){
            formIsValid = false;
            errors['price'] = 'لطفا هزینه کلاس را وارد کنید!';
        }else {
            errors['price'] = null;
        }

        this.setState({errors}, ()=>{
            return callback(formIsValid);
        });
    }

    selectFile(text , id, btnid, imgid){

        $('#'+btnid).addClass('btn-outline-warning');
        $('#'+btnid).removeClass('btn-outline-danger');
        $('#'+btnid+' p').text("در حال بارگذاری ...");
        let filesize = ((text.target.files[0].size/1024)/1024).toFixed(4);

        if (filesize >= 5){
            this.props.toast("فایل بیشتر از 5 مگابایت حجم دارد",3000,"bg-warning",()=> {
                $('#liveToast').toast('show');
            });

            $('#'+btnid).addClass('btn-outline-primary');
            $('#'+btnid).removeClass('btn-outline-warning');
            $('#'+btnid+' p').text("انتخاب عکس");
        }else {
            let filename = this.generate_random_string(6,'qwertyuiopasdfghjklzxcvbnm0123456789')+'_'+text.currentTarget.files[0].name;
            const url = Data.mainserver+'uploadFile.php';
            const formData = new FormData();
            formData.append('file',text.target.files[0],filename);

            const config = {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'ENCType': 'multipart/form-data'
                }
            };
            axios.post(url, formData,config)
                .then(response => {

                    console.log(response.data)
                    if (response.data.hasOwnProperty('filename')){
                        const {fields} = this.state;
                        fields['file'] = response.data.filename;
                        this.setState({fields});
                        $('#'+imgid)[0].src = Data.mainserver+"images/"+response.data.filename;
                        $('#'+btnid).addClass('btn-outline-success');
                        $('#'+btnid).removeClass('btn-outline-warning');
                        $('#'+btnid+' span').removeClass('invisible');
                        $('#'+btnid+' p').text("عکس پیوست شد");
                    }
                })
                .catch(error => {
                    $('#'+btnid).addClass('btn-outline-danger');
                    $('#'+btnid).removeClass('btn-outline-warning')
                    $('#'+btnid+' p').text("عکس پیوست نشد !!!");
                    console.log(error);
                });
        }

    }
    deleteFile(e , imgid){

        $('#'+imgid)[0].src = Data.mainserver+"images/ic.jpg";

        const {fields} = this.state;
        fields['file'] = "";
        this.setState({fields});

    }

    generate_random_string(length,text){
        var result           = '';
        var charactersLength = text.length;
        for ( var i = 0; i < length; i++ ) {
            result += text.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    }

    handleRequest(){
        $('#waitspinner').modal('show');

        const {inst,classname,price,isGroup,dayid,day,file,instrumentList,time} = this.state.fields;
        let type = 0;
        if(isGroup){
            type=1;
        }
        let filename = "ic.jpg";
        if(file != ""){
            filename=file;
        }
        let data = new FormData();
        data.append('masterid',this.props.products['id']);
        data.append('instrumentname',classname);
        data.append('instrumenticon',instrumentList[inst]['icon']);
        data.append('price',price);
        data.append('masterpicture',filename);
        data.append('type',type+"");
        data.append('dayid',dayid);
        data.append('day',day);
        data.append('time',time);

        axios.post(Data.server+'addClass.php',data)
            .then(response=>{

                console.log(response.data);

                $('#waitspinner').modal('hide');
                $('div.modal-backdrop.fade.show').remove();

                if (response.data === "ok") {

                    this.props.toast("ویرایش با موفقیت انجام شد",3000,"bg-success",()=> {
                        $('#liveToast').toast('show');
                        window.location.reload();
                    });

                }
                
                if (response.data.includes("insert error")){
                    this.props.toast("خطای داخلی رخ داد",3000,"bg-danger",()=> {
                        $('#liveToast').toast('show');
                    });
                }

            })
            .catch(error=>{
                $('#progressTop').addClass('invisible');
                $('#r_fab').addClass('animate__animated animate__zoomIn');
                console.log(error);
            });
    }

    handleTimeChange(time,name){
        let fields = this.state.fields;
        moment.locale('en');
        fields[name] = moment(time).isValid()?time:new Date();
        let time1 = moment(fields['fromtime']).format("HH:mm");
        let time2 = moment(fields['totime']).format("HH:mm");
        fields['time'] = time1+"-"+time2;
        this.setState({fields});
    }
    render() {
        const {id,masterid,products,index} = this.props;

        const {inst, classname , price , isGroup , fromtime , totime , dayid , instrumentList} = this.state.fields;

        const {errors} = this.state;

        let uploadid = "upload-file"+id;
        let btnid = "btn_file"+id;
        let imgid = "masterpicture"+id;
        return (
            <div className="modal fade" id={id} tabIndex="-1" aria-labelledby={id+"Label"}
                                         aria-hidden="true">
                <div className="modal-dialog modal-dialog-scrollable modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h6 className="modal-title" id={id+"Label"}>{"تعریف کلاس استاد "+products['name']}</h6>
                            <button type="button" className="close text-left ml-0" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            
                            <img id={imgid} src={Data.mainserver+"images/ic.jpg"} className="addclassimg" />        


                            <input
                                className="novisible"
                                id={uploadid}
                                multiple
                                type="file"
                                accept="image/jpeg, image/png"
                                onChange={(e) => this.selectFile(e,products['id'],btnid,imgid)}
                            />
                            <button onClick={(e) => $('#'+uploadid).trigger('click')} type="button" id={btnid} className="btn btn-outline-primary mt-3 w-100 d-flex align-items-center justify-content-center">
                                <span className="oi oi-check invisible"/>
                                <p className="px-4 py-1 my-0 text-dark">{"انتخاب عکس (ترجیحا HD یا fullHD)"}</p>
                                <span className="oi oi-file"/>
                            </button>
                            <small>فقط فایل های کمتر از 5 مگابایت بارگذاری میشود</small>
                            <button onClick={(e) => this.deleteFile(e,imgid)} type="button" id="delbtn" className="btn btn-outline-danger mt-3 w-100 d-flex align-items-center justify-content-center">
                                <span className="oi oi-check invisible"/>
                                <p className="px-4 py-1 my-0 text-dark">حذف عکس</p>
                                <span className="oi oi-file"/>
                            </button>
                            <strong className='my-2'>پر کردن فیلدهای ستاره دار اجباری است</strong>



                            <form className="login-form mx-auto">
                                <div className="form-group text-right">
                                    <label className='important-input' for="exampleFormControlSelect1">انتخاب ساز</label>
                                    <select 
                                        type="inst"
                                        className={["form-control", errors['inst'] ? 'is-invalid':'is-valid'].join(' ')}
                                        name="inst"
                                        value={inst}
                                        onChange={this.handleChange.bind(this)}
                                        placeholder="لطفا ساز استاد را انتخاب کنید"
                                        id="exampleFormControlSelect1">
                                            {instrumentList.map((products, index) => 
                                                <option key={index} value={index}>{products['name']}</option>
                                            )}
                                    </select>
                                    <span className="invalid-feedback rtl" style={{display : errors['inst'] ? 'block':'none'}}>{errors['inst']}</span>
                                </div>
                                <div className="form-check text-right">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        name="isGroup"
                                        value={isGroup}
                                        onChange={this.handleChange.bind(this)}
                                        id="flexCheckDefault"/>
                                    <label className="form-check-label" for="flexCheckDefault">
                                        آیا کلاس گروه نوازی است ؟
                                    </label>
                                </div>
                                <div className={[isGroup? "visible":"invisible","form-check","text-right"].join(" ")}>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <TimePicker
                                        variant='static'
                                        ampm={false}
                                        label="از ساعت"
                                        name='fromtime'
                                        value={fromtime}
                                        onChange={(time) => this.handleTimeChange(time,'fromtime')}/>
                                    <TimePicker
                                        variant='static'
                                        ampm={false}
                                        trapFocusProps={{ disableEnforceFocus: true, disablePortal: true }}
                                        label="تا ساعت"
                                        name='totime'
                                        value={totime}
                                        onChange={(time) => this.handleTimeChange(time,'totime')}/>
                                </MuiPickersUtilsProvider>
                                
                                </div>
                                <div className="form-group text-right">
                                    <label className='important-input'>نام کلاس</label>
                                    <input
                                        type="classname"
                                        className={["form-control", errors['classname'] ? 'is-invalid':'is-valid'].join(' ')}
                                        name="classname"
                                        value={classname}
                                        onChange={this.handleChange.bind(this)}
                                        placeholder="لطفا نام کلاس را وارد کنید"/>
                                    <span className="invalid-feedback rtl" style={{display : errors['classname'] ? 'block':'none'}}>{errors['classname']}</span>
                                </div>
                                
                                <div className="form-group text-right">
                                    <label>{"هزینه یک جلسه"}</label>
                                    <input
                                        type="price"
                                        className={["form-control", errors['price'] ? 'is-invalid':'is-valid'].join(' ')}
                                        name="price"
                                        value={price}
                                        onInput={(e) => {
                                            e.target.value = e.target.value.replace(/\D/g, "")
                                        }}
                                        onChange={this.handleChange.bind(this)}
                                        placeholder="اگر هزینه کلاس , شهریه پیش فرض آموزشگاه میباشد مقدار را 0 بگذارید"/>
                                    <span className="invalid-feedback rtl" style={{display : errors['price'] ? 'block':'none'}}>{errors['price']}</span>
                                    <strong className="feedback rtl">اگر هزینه کلاس , شهریه پیش فرض آموزشگاه میباشد مقدار را 0 بگذارید</strong>
                                    
                                </div>
                                <div className="form-group text-right">
                                    <label className='important-input' for="exampleFormControlSelect2">روز برگذاری کلاس</label>
                                    <select 
                                        type="dayid"
                                        className={["form-control", errors['inst'] ? 'is-invalid':'is-valid'].join(' ')}
                                        name="dayid"
                                        value={dayid}
                                        onChange={this.handleChange.bind(this)}
                                        placeholder="لطفاروز کلاس را انتخاب کنید"
                                        id="exampleFormControlSelect2">
                                            
                                            <option value={0}>شنبه</option>
                                            <option value={1}>یکشنبه</option>
                                            <option value={2}>دوشنبه</option>
                                            <option value={3}>سه شنبه</option>
                                            <option value={4}>چهارشنبه</option>
                                            <option value={5}>پنج شنبه</option>
                                            
                                    </select>
                                    <span className="invalid-feedback rtl" style={{display : errors['dayid'] ? 'block':'none'}}>{errors['dayid']}</span>
                                </div>

                            </form>
                        </div>
                        <div className="modal-footer">
                            <div className="btn-group">
                                <button type="submit" className="btn btn-info" onClick={this.handleSubmit.bind(this)} >تایید</button>
                                <button type="button" className="btn btn-secondary" data-dismiss="modal">لغو</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        )
    }
}

export default ModalAddClass;
